var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconUserMax(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34 32H30C23.1068 32.0079 16.4982 34.7498 11.624 39.624C6.74977 44.4982 4.00794 51.1068 4 58C4 58.5304 4.21071 59.0391 4.58579 59.4142C4.96086 59.7893 5.46957 60 6 60H58C58.5304 60 59.0391 59.7893 59.4142 59.4142C59.7893 59.0391 60 58.5304 60 58C59.9921 51.1068 57.2502 44.4982 52.376 39.624C47.5018 34.7498 40.8932 32.0079 34 32Z",
    fill: "#D4E1F9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32 36C40.8366 36 48 28.8366 48 20C48 11.1634 40.8366 4 32 4C23.1634 4 16 11.1634 16 20C16 28.8366 23.1634 36 32 36Z",
    fill: "#93B5F1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUserMax);
export default __webpack_public_path__ + "static/media/IconUserMax.944d789e5354fed114c29c058b8588fb.svg";
export { ForwardRef as ReactComponent };